import { InvisibleStylePart, Visibility } from "@kuika/kuika-cl-model";
import { PartialContextProvider } from "../../../shared/patial/partial-context-provider";
import { IScreenDesignContextState } from "../screen-design-context";
import { IScreenDesignContextProviderProps, ScreenDesignContextProvider } from "../screen-design-context-provider";

export interface InvisibleStylesProviderState {
  getStylesVisibility: (invisibleStylePart: InvisibleStylePart) => Visibility;
}

export class InvisibleStylesProvider extends PartialContextProvider<
  ScreenDesignContextProvider,
  IScreenDesignContextProviderProps,
  IScreenDesignContextState,
  InvisibleStylesProviderState
> {
  static defaultState: InvisibleStylesProviderState = {
    getStylesVisibility: () => {
      return {} as Visibility;
    }
  };

  getProviderValues = (): InvisibleStylesProviderState => {
    return {
      getStylesVisibility: this.getStylesVisibility
    };
  };

  getStylesVisibility = (invisibleStylePart: InvisibleStylePart): Visibility => {
    let result: Visibility = Visibility.Visible;
    const selectedDi = this.partial.displayItemProvider.getSelectedDisplayItem();
    const componentDefs = this.state?.project?.componentSetObj?.components;
    if (!componentDefs || !selectedDi) {
      return result;
    }
    const selectedComponentId = selectedDi.item.id;
    const component = componentDefs.find((x) => x.id === selectedComponentId);
    if (component && component.inVisibleStyles && component.inVisibleStyles.length > 0) {
      switch (invisibleStylePart) {
        case InvisibleStylePart.Layout: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_Padding: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_Padding)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_AlignItems: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_AlignItems)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_TextAlign: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_TextAlign)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_Display: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_Display)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_Width: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_Width)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_Height: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_Height)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_MinWidth: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_MinWidth)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_MinHeight: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_MinHeight)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_MaxWidth: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_MaxWidth)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_MaxHeight: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_MaxHeight)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_XAxis: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_XAxis)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Layout_YAxis: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Layout_YAxis)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Text: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Text)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Text_Color: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Text_Color)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Text_FontFamily: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Text_FontFamily)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Text_FontSize: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Text_FontSize)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Text_FontWeight: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Text_FontWeight)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Text_LetterSpacing: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Text_LetterSpacing)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Text_LineHeight: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Text_LineHeight)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Text_TextDecoration: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Text_TextDecoration)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Text_TextTransform: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Text_TextTransform)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Text_DontAffectedMobileSystem: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Text_DontAffectedMobileSystem)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Fill: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Fill)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Fill_BackgroundImage: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Fill_BackgroundImage)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Fill_BackgroundImagePosition: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Fill_BackgroundImagePosition)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Fill_BackgroundImageSize: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Fill_BackgroundImageSize)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Fill_Color: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Fill_Color)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Fill_RepeatSwitch: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Fill_RepeatSwitch)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Border: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Border)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Border_Color: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Border_Color)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Border_Radius: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Border_Radius)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Border_Style: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Border_Style)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Border_Width: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Border_Width)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Shadow: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Shadow)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Shadow_Color: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Shadow_Color)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Shadow_Structure: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Shadow_Structure)) {
            result = Visibility.Hidden;
          }
          break;
        }
        case InvisibleStylePart.Effects: {
          if (component.inVisibleStyles.includes(InvisibleStylePart.Effects)) {
            result = Visibility.Hidden;
          }
          break;
        }
        default: {
          break;
        }
      }
    }
    return result;
  };
}
